import { TTabView } from '../Components/Shared/Tabs/Tabs';
import { PrivateRoutes } from '../Router/Routes';
import { useParams, generatePath } from 'react-router-dom';
import OrganizationProfileGeneral from 'Page/OrganizationProfile/Tabs/TabGeneral/TabGeneral';
import OrganizationProfileDomains from 'Page/OrganizationProfile/Tabs/TabDomains/TabDomains';
import OrganizationProfileSecurity from 'Page/OrganizationProfile/Tabs/TabSecurity/TabSecurity';
import OrganizationProfileUsers from 'Page/OrganizationProfile/Tabs/TabUsers/TabUsers';

interface Props {
  organization: IOrganization;
}

const useTabsOrganizationProfile = ({ organization }: Props): TTabView[] => {
  const { accountCode, organizationCode } = useParams<{
    accountCode: string;
    organizationCode: string;
  }>();

  const getPath = (path: string) =>
    generatePath(path, {
      accountCode,
      organizationCode
    });

  const tabs: TTabView[] = [
    {
      title: 'page.organizationProfile.menu.general',
      path: PrivateRoutes.organizationProfile.path,
      link: getPath(PrivateRoutes.organizationProfile.path),
      component: <OrganizationProfileGeneral organization={organization} />
    },
    {
      title: 'page.organizationProfile.menu.domains',
      path: PrivateRoutes.organizationProfileDomains.path,
      link: getPath(PrivateRoutes.organizationProfileDomains.path),
      component: <OrganizationProfileDomains organization={organization} />
    },
    {
      title: 'page.organizationProfile.menu.security',
      path: PrivateRoutes.organizationProfileSecurity.path,
      link: getPath(PrivateRoutes.organizationProfileSecurity.path),
      component: <OrganizationProfileSecurity />
    },
    {
      title: 'page.organizationProfile.menu.users',
      path: PrivateRoutes.organizationProfileUsers.path,
      link: getPath(PrivateRoutes.organizationProfileUsers.path),
      component: <OrganizationProfileUsers organization={organization} />
    },
  ];

  return tabs;
};

export default useTabsOrganizationProfile;
